// src/components/DatePlanning.js - VERSION FINALE CORRIGÉE
import React, { useState, useEffect } from 'react';  // ⭐ AJOUT useEffect
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { API_BASE_URL } from '../config';
import './DatePlanning.css';



// ⭐ AJOUTER CETTE FONCTION ICI
const createGoogleMapsLink = (suggestion, city = 'Paris') => {
  // Construction de la requête de recherche
  const query = `${suggestion.type} ${city}`;
  
  // Création du lien Google Maps
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`;
};
 
const DatePlanning = ({ conversationId, girlInfo, onClose, datePlanningData, refreshCredits, onMessageUsed }) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  
  // États
  const [loading, setLoading] = useState(false);
  const [analysis, setAnalysis] = useState(null);
  const [datePlanningId, setDatePlanningId] = useState(null);
  const [error, setError] = useState('');
  const [userSuggestion, setUserSuggestion] = useState('');
  const [showSuggestionInput, setShowSuggestionInput] = useState(false);

  // ⭐⭐⭐ NOUVEAU : Initialiser analysis depuis datePlanningData
  useEffect(() => {
    console.log('🔄 DatePlanning mounted avec datePlanningData:', datePlanningData);
    
    if (datePlanningData?.analysis) {
      console.log('✅ Initialisation de analysis depuis datePlanningData.analysis');
      console.log('📊 Analysis:', datePlanningData.analysis);
      setAnalysis(datePlanningData.analysis);
    } else {
      console.warn('⚠️ datePlanningData.analysis est manquant !');
      console.log('datePlanningData reçu:', datePlanningData);
    }
  }, [datePlanningData]);

  // Fonction : Analyser et obtenir suggestions
  const handlePlanDate = async (withUserSuggestion = false) => {
    try {
      setLoading(true);
      setError('');

      const token = localStorage.getItem('token');

      const body = {
        conversation_id: conversationId,
        language: i18n.language,
      };

      if (withUserSuggestion && userSuggestion.trim()) {
        body.user_suggestion = userSuggestion.trim();
      }

      const response = await fetch(`${API_BASE_URL}/wingman/plan-date`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
      });

      const data = await response.json();

      if (!response.ok || !data.success) {
        throw new Error(data.message || t('datePlanning:errors.analysisError'));
      }

      // On met à jour l'analyse locale
      setAnalysis(data.analysis);

      if (refreshCredits) {
        refreshCredits();
      }

      console.log('✅ Date planning reçu:', data);
    } catch (err) {
      console.error('❌ Erreur plan date:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleCopy = (text) => {
    navigator.clipboard.writeText(text);
    alert(t('datePlanning:alerts.messageCopied'));
  };

  // ⭐⭐ FONCTION CRITIQUE : Utiliser une suggestion
  const handleUseSuggestion = async (suggestion) => {
    try {
      if (!datePlanningData?.date_planning_id) {
        console.error('❌ date_planning_id manquant dans datePlanningData !');
        console.error('datePlanningData reçu:', datePlanningData);
        alert('Erreur : ID du date planning introuvable');
        return;
      }

      if (!datePlanningData?.wingman_interaction_id) {
        console.error('❌ wingman_interaction_id manquant dans datePlanningData !');
        console.error('datePlanningData reçu:', datePlanningData);
        alert('Erreur : ID wingman_interaction introuvable');
        return;
      }

      console.log('📤 Envoi mark-date-used avec:', {
        date_planning_id: datePlanningData.date_planning_id,
        wingman_interaction_id: datePlanningData.wingman_interaction_id,
        suggestion_id: suggestion.id,
        suggestion_content: suggestion.message_to_send
      });

      const token = localStorage.getItem('token');

      const response = await fetch(`${API_BASE_URL}/wingman/mark-date-used`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          date_planning_id: datePlanningData.date_planning_id,
          wingman_interaction_id: datePlanningData.wingman_interaction_id,
          suggestion_id: suggestion.id,
          suggestion_content: suggestion.message_to_send,
        }),
      });

      const data = await response.json();
      console.log('📥 Réponse mark-date-used:', data);

      if (!response.ok || !data.success) {
        throw new Error(data.message || 'Erreur lors du marquage');
      }

      // Petit délai pour laisser MySQL finir
      await new Promise((resolve) => setTimeout(resolve, 300));

      // Copier le message dans le presse-papiers
      await navigator.clipboard.writeText(suggestion.message_to_send);

      console.log('✅ Appel onMessageUsed pour recharger l\'historique');
      
      // Recharger l'historique si le parent a passé un callback
      if (onMessageUsed) {
        await onMessageUsed();
      }

      alert(t('datePlanning:alerts.suggestionUsed'));
      onClose();
    } catch (err) {
      console.error('❌ Erreur mark date used:', err);
      alert(`Erreur: ${err.message}`);
    }
  };

  // Rendu : État initial
  if (!analysis && !loading) {
    return (
      <div className="date-planning-modal">
        <div className="date-planning-content">
          <div className="date-planning-header">
            <h2>{t("datePlanning:header.title", { name: girlInfo?.name })}</h2>
            <button className="close-btn" onClick={onClose}>✕</button>
          </div>

          <div className="date-planning-body">
            <div className="intro-section">
              <div className="intro-icon">🎯</div>
              <h3>{t("datePlanning:intro.title")}</h3>
              <p>{t("datePlanning:intro.subtitle")}</p>
              <ul>
                <li>{t("datePlanning:intro.feature1")}</li>
                <li>{t("datePlanning:intro.feature2")}</li>
                <li>{t("datePlanning:intro.feature3")}</li>
                <li>{t("datePlanning:intro.feature4")}</li>
              </ul>
            </div>

            <div className="action-buttons">
              <button 
                className="btn-primary btn-large"
                onClick={() => handlePlanDate(false)}
                disabled={loading}
              >
                {loading ? t('datePlanning:buttons.analyzing') : t('datePlanning:buttons.analyze')}
              </button>

              <button 
                className="btn-secondary"
                onClick={() => setShowSuggestionInput(!showSuggestionInput)}
              >
                {t('datePlanning:buttons.customIdea')}
              </button>
            </div>

            {showSuggestionInput && (
              <div className="user-suggestion-input">
                <label>{t("datePlanning:custom.label")}</label>
                <input
                  type="text"
                  placeholder={t("datePlanning:custom.placeholder")}
                  value={userSuggestion}
                  onChange={(e) => setUserSuggestion(e.target.value)}
                />
                <button 
                  className="btn-primary"
                  onClick={() => handlePlanDate(true)}
                  disabled={!userSuggestion.trim() || loading}
                >
                  {t('datePlanning:custom.generate')}
                </button>
              </div>
            )}

            {error && (
              <div className="error-message">
                ❌ {error}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  // Rendu : Loading
  if (loading) {
    return (
      <div className="date-planning-modal">
        <div className="date-planning-content">
          <div className="loading-state">
            <div className="spinner-large"></div>
            <h3>{t("datePlanning:loading.analyzing")}</h3>
            <p>{t("datePlanning:loading.subtitle")}</p>
          </div>
        </div>
      </div>
    );
  }

  // ⭐ Log pour debug
  console.log('📊 Analysis actuel pour le rendu:', analysis);

  // Rendu : Résultats - TROP TÔT
  if (analysis && analysis.date_readiness.level === 'too_early') {
    return (
      <div className="date-planning-modal">
        <div className="date-planning-content">
          <div className="date-planning-header">
           <h2>{t("datePlanning:header.title", { name: girlInfo?.name })}</h2>
            <button className="close-btn" onClick={onClose}>✕</button>
          </div>

          <div className="date-planning-body">
            <div className="alert-section alert-red">
              <div className="alert-header">
                {t('datePlanning:tooEarly.title')}
              </div>
              <div className="score-display">
                {t("datePlanning:readiness.score", { score: Math.round(analysis.date_readiness.score * 100) })}
              </div>
            </div>

            <div className="red-flags-section">
              <h4>{t("datePlanning:sections.concerns")}</h4>
              <ul>
                {analysis.date_readiness.red_flags.map((flag, i) => (
                  <li key={i}>{flag}</li>
                ))}
              </ul>
            </div>

            <div className="recommendation-section">
              <h4>{t("datePlanning:sections.whatToDo")}</h4>
              <p>{analysis.date_readiness.recommendation}</p>
            </div>

            <div className="action-buttons">
              <button className="btn-secondary" onClick={onClose}>
                {t('datePlanning:buttons.close')}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // Rendu : Résultats - PRÊT ou TIMING À SURVEILLER
  if (analysis && (analysis.date_readiness.level === 'ready' || analysis.date_readiness.level === 'watch_timing' || analysis.date_readiness.level === 'too_late')) {
    const hasAlerts = analysis.alerts && (
      analysis.alerts.has_timing_alert ||
      analysis.alerts.has_budget_alert ||
      analysis.alerts.has_compatibility_alert
    );

    return (
      <div className="date-planning-modal">
        <div className="date-planning-content">
          <div className="date-planning-header">
            <h2>{t("datePlanning:header.title", { name: girlInfo?.name })}</h2>
            <button className="close-btn" onClick={onClose}>✕</button>
          </div>

          <div className="date-planning-body">
            {/* Readiness Score */}
            <div className={`readiness-section ${
              analysis.date_readiness.level === 'ready' ? 'alert-green' :
              analysis.date_readiness.level === 'watch_timing' ? 'alert-yellow' :
              'alert-orange'
            }`}>
              <div className="readiness-header">
                {analysis.date_readiness.level === 'ready' && t('datePlanning:readiness.ready')}
                {analysis.date_readiness.level === 'watch_timing' && t('datePlanning:readiness.watchTiming')}
                {analysis.date_readiness.level === 'too_late' && t('datePlanning:readiness.tooLate')}
              </div>
              <div className="score-display">
                {t("datePlanning:readiness.score", { score: Math.round(analysis.date_readiness.score * 100) })}
              </div>
            </div>

            {/* Green Flags */}
            {analysis.date_readiness.green_flags.length > 0 && (
              <div className="green-flags-section">
                <h4>{t("datePlanning:sections.greenFlags")}</h4>
                <ul>
                  {analysis.date_readiness.green_flags.map((flag, i) => (
                    <li key={i}>{flag}</li>
                  ))}
                </ul>
              </div>
            )}

            {/* Recommandation */}
            <div className="recommendation-section">
              <h4>{t("datePlanning:sections.recommendation")}</h4>
              <p>{analysis.date_readiness.recommendation}</p>
            </div>

            {/* ALERTES si présentes */}
            {hasAlerts && (
              <div className="alerts-container">
                {analysis.alerts.has_compatibility_alert && (
                  <div className="alert-box alert-compatibility">
                    <div className="alert-box-header">
                      {t('datePlanning:sections.compatibilityAlert')}
                    </div>
                    <p>{analysis.alerts.compatibility_message}</p>
                    {analysis.user_suggestion_analysis && (
                      <div className="compatibility-details">
                        <p><strong>{t("datePlanning:details.yourSuggestion")}</strong> {analysis.user_suggestion_analysis.suggestion}</p>
                        <p><strong>{t("datePlanning:details.compatibilityScore")}</strong> {Math.round(analysis.user_suggestion_analysis.compatibility_score * 100)}%</p>
                        <p><strong>{t("datePlanning:details.problem")}</strong> {analysis.user_suggestion_analysis.why_problematic}</p>
                      </div>
                    )}
                  </div>
                )}

                {analysis.alerts.has_budget_alert && (
                  <div className="alert-box alert-budget">
                    <div className="alert-box-header">
                      {t('datePlanning:sections.budgetAlert')}
                    </div>
                    <p>{analysis.alerts.budget_message}</p>
                  </div>
                )}
              </div>
            )}

            {/* Suggestions de Dates */}
            <div className="suggestions-container">
              <h3>{hasAlerts ? t("datePlanning:sections.suggestionsAlt") : t("datePlanning:sections.suggestions")}</h3>
              
              {analysis.date_suggestions.map((suggestion, index) => (
                <div key={suggestion.id} className={`date-suggestion-card ${
                  suggestion.type === 'perfect_match' ? 'perfect-match' : ''
                }`}>
                  <div className="suggestion-header">
                    <div className="suggestion-title">
                      {suggestion.type === 'perfect_match' && t('datePlanning:suggestionTypes.perfectMatch')}
                      {suggestion.type === 'safe_classic' && t('datePlanning:suggestionTypes.safeClassic')}
                      {suggestion.type === 'activity_based' && t('datePlanning:suggestionTypes.activityBased')}
                      {suggestion.type === 'unique_memorable' && t('datePlanning:suggestionTypes.uniqueMemorable')}
                      {!['perfect_match', 'safe_classic', 'activity_based', 'unique_memorable'].includes(suggestion.type) && 
                        `OPTION ${index + 1}`}
                    </div>
                    <div className="success-rate">
                      {suggestion.success_rate && t("datePlanning:suggestionTypes.successRate", { rate: Math.round(suggestion.success_rate * 100) })}
                    </div>
                  </div>

                  <div className="suggestion-activity">
                    <h4>{suggestion.activity || suggestion.title}</h4>
                  </div>

                  {suggestion.description && (
                    <div className="suggestion-description">
                      <p>{suggestion.description}</p>
                    </div>
                  )}

                  <div className="suggestion-details">
                    {suggestion.location && (
                      <div className="detail-item">
                        <span className="detail-icon">📍</span>
                        <span>{suggestion.location}</span>
                      </div>
                    )}
                    <div className="detail-item">
                      <span className="detail-icon">⏰</span>
                      <span>{suggestion.timing}{suggestion.duration && ` • ${suggestion.duration}`}</span>
                    </div>
                    {suggestion.budget && (
                      <div className="detail-item">
                        <span className="detail-icon">💰</span>
                        <span>{suggestion.budget}</span>
                      </div>
                    )}
                    <div className="detail-item">
                      <span className="detail-icon">🎭</span>
                      <span>{suggestion.vibe}</span>
                    </div>
                  </div>

                  <div className="suggestion-why">
                    <strong>{t("datePlanning:suggestionDetails.whyItWorks")}</strong>
                    <p>{suggestion.why_it_works || suggestion.why}</p>
                  </div>

                  {/* LIGNE 439-442 */}
<div className="suggestion-message">
  <strong>{t('datePlanning:message_to_send')}</strong>
  <p className="message-preview">"{suggestion.message_to_send}"</p>
</div>

{/* LIGNE 444-471 */}
<div className="suggestion-actions">
  {/* Bouton Google Maps */}
  <a
    // APRÈS
href={createGoogleMapsLink(suggestion, girlInfo?.city || 'Paris')}
    target="_blank"
    rel="noopener noreferrer"
    className="btn-maps"
  >
   🗺️ {t('datePlanning:buttons.findPlaces', { type: suggestion.type })}
  </a>
  
  {/* Bouton Copier */}
  <button
    className="btn-copy"
    onClick={() => handleCopy(suggestion.message_to_send)}
  >
    📋 {t('datePlanning:buttons.copy')}
  </button>
  
  {/* Bouton Utiliser */}
  <button
    className="btn-use"
    onClick={() => handleUseSuggestion(suggestion)}
  >
    ✅ {t('datePlanning:buttons.use')}
  </button>
</div>

                  {suggestion.pro_tips && suggestion.pro_tips.length > 0 && (
                    <div className="suggestion-tips">
                      <strong>{t("datePlanning:suggestionDetails.proTips")}</strong>
                      <ul>
                        {suggestion.pro_tips.map((tip, i) => (
                          <li key={i}>{tip}</li>
                        ))}
                      </ul>
                    </div>
                  )}

                  <div className="suggestion-actions">
                    <button 
                      className="btn-copy"
                      onClick={() => handleCopy(suggestion.message_to_send)}
                    >
                      {t('datePlanning:buttons.copyMessage')}
                    </button>
                    <button 
                      className="btn-use"
                      onClick={() => handleUseSuggestion(suggestion)}
                    >
                      {t('datePlanning:buttons.useOption')}
                    </button>
                  </div>
                </div>
              ))}
            </div>

            {/* Insights Psychologiques */}
            {analysis.psychological_insights && (
              <div className="insights-section">
                <h4>{t("datePlanning:insights.title")}</h4>
                
                <div className="insight-box">
                  <strong>{t("datePlanning:insights.herMindset")}</strong>
                  <p>{analysis.psychological_insights.her_mindset}</p>
                </div>

                <div className="insight-box">
                  <strong>{t("datePlanning:insights.herExpectations")}</strong>
                  <p>{analysis.psychological_insights.her_expectations}</p>
                </div>

                <div className="avoid-want-grid">
                  <div className="avoid-section">
                    <strong>{t("datePlanning:insights.toAvoid")}</strong>
                    <ul>
                      {analysis.psychological_insights.what_to_avoid.map((item, i) => (
                        <li key={i}>{item}</li>
                      ))}
                    </ul>
                  </div>

                  <div className="want-section">
                    <strong>{t("datePlanning:insights.whatSheWants")}</strong>
                    <ul>
                      {analysis.psychological_insights.what_she_wants.map((item, i) => (
                        <li key={i}>{item}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            )}

            <div className="action-buttons">
              <button className="btn-secondary" onClick={onClose}>
                {t('datePlanning:buttons.close')}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return null;
};

export default  DatePlanning;